import { render, staticRenderFns } from "./SlideSelector.vue?vue&type=template&id=1a8febb2&scoped=true&"
import script from "./SlideSelector.vue?vue&type=script&lang=js&"
export * from "./SlideSelector.vue?vue&type=script&lang=js&"
import style0 from "./SlideSelector.vue?vue&type=style&index=0&id=1a8febb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8febb2",
  null
  
)

export default component.exports